<script setup lang="ts">
import { inject } from "vue";
import { EditableComponent } from "@magnolia/vue-editor";
import { mapNodes } from "~/utils/helper/magnolia";
import { contentToResponsiveGapClasses, contentToTailwindClasses } from "~/utils/helper/tailwind";

export interface SectionComponentAreaProps {
  content?: object;
}

defineProps<SectionComponentAreaProps>();

const spacing = inject("spacing");
const contentWidth = inject("contentWidth");
</script>

<template>
  <div
    :class="[
      { 'mx-auto': (contentWidth ?? content.contentWidth) < 12 },
      contentToTailwindClasses({
        width: { md: contentWidth ?? content.contentWidth },
      }),
      contentToResponsiveGapClasses({
        gap: spacing ?? content.spacing,
      }),
    ]"
    class="flex flex-col"
  >
    <EditableComponent
      v-for="childContent in mapNodes(content)"
      :key="childContent['@id']"
      :content="childContent"
    />
  </div>
</template>
